import { $ } from "./imports";
import { getLanguage } from "./get-language";

const formFunctions = () => {

    /*==================== VALIDATIONS ====================*/

    const patronLetras = /^[a-zA-ZäÄëËïÏöÖüÜáéíóúáéíóúñÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙÑ ]*$/;
    const patronNumeros = /^([\(\)\+0-9\s\-\#]+)$/;
    const patronCorreo = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    const patronEspacios = /\S{3,}/gm;

    const validationMessages = {
        "es": {
            "letterwithbasicpunc": "Ingrese solo letras y espacios",
            "emailValidate": "Ingrese un correo electrónico válido",
            "onlyWhiteSpaceValidate": "Sin espacios en blanco por favor",
            "captchaError": "El captcha es obligatorio."
        },
        "en": {
            "letterwithbasicpunc": "Enter only letters and spaces",
            "emailValidate": "Enter a valid email address",
            "onlyWhiteSpaceValidate": "No blank spaces please",
            "captchaError": "The captcha is mandatory."
        }
    }

    function additionalValidationRules() {
        // Solo letras y espacios con puntuación basica (No números)
        $.validator.addMethod("letterwithbasicpunc", function (value, element) {
            if (patronLetras.test(value)) {
                return true;
            } else {
                return false;
            };
        }, validationMessages[getLanguage()].letterwithbasicpunc );

        // Email valido
        $.validator.addMethod("emailValidate", function (value, element) {
            if (patronCorreo.test(value)) {
                return true;
            } else {
                return false;
            };
        }, validationMessages[getLanguage()].emailValidate );

        // Si solo llena de espacios
        $.validator.addMethod("onlyWhiteSpaceValidate", function (value, element) {
            if (value.trim()==null || value.trim()==""|| value===" ") {
                return false;
            }
            else {
                return true;
            }
            // if (patronEspacios.test(value)) {
            //     return true;
            // } else {
            //     return false;
            // };
        }, validationMessages[getLanguage()].onlyWhiteSpaceValidate );

    }

    const captchaValidation = (form) => {
        let response = grecaptcha.getResponse();
        if (response.length) {
          // console.log('reCAPTCHA valido');
          $(form).find('.captcha').removeClass('error-validation-captcha');
          $(form).find('.captcha #captchaError').remove();
          return true;
        } else {
          // console.log('reCAPTCHA error');
          $(form).find('.captcha').addClass('error-validation-captcha');
          $(form).find('.captcha').append(`<div id="captchaError" class="error-validacion">${validationMessages[getLanguage()].captchaError}</div>`)
          return false;
        }
    }

    function validateForm($formSelector) {
        $formSelector.validate({
            rules: {
                // Nombre
                name: {
                    required: true,
                    letterwithbasicpunc: true,
                    maxlength: 255,
                    onlyWhiteSpaceValidate: true,
                },
                // Correo
                email: {
                    required: true,
                    email: true,
                    emailValidate: true,
                    maxlength: 320,
                },
                // Motivo
                select_reason: {
                    required: true,
                },
                // Mensaje
                text: {
                    required: true,
                    onlyWhiteSpaceValidate: true,
                    minlength: 4,
                },
            },
            messages: {
                name: {
                    pattern: validationMessages[getLanguage()].letterwithbasicpunc,
                },
                email: {
                    email: validationMessages[getLanguage()].emailValidate
                },
            },
            errorClass: 'error-validacion', // Clase para las alertas de validación
            errorElement: 'div', // Elemento "html" para mostrar el error
            submitHandler: function (form) {
                if (captchaValidation(form)) {
                  form.submit();
                }
            }
        });
    }

    function validateNewsletterForm($formSelector) {
        $formSelector.validate({
            rules: {
                // Correo
                email_newsletter: {
                    required: true,
                    email: true,
                    emailValidate: true,
                    maxlength: 320,
                },
            },
            messages: {
                email_newsletter: {
                    email: validationMessages[getLanguage()].emailValidate
                },
            },
            errorClass: 'error-validacion', // Clase para las alertas de validación
            errorElement: 'div', // Elemento "html" para mostrar el error
        });
    }

    function replaceInputWithBtn($formSelector, btnClass = 'button--primary'){
        if($formSelector.find('.form-actions input[type="submit"]').length){
            // Obtener el inputs submit original
            let $submitInputs = $formSelector.find('.form-actions input[type="submit"]');

            // Filtrar el input submit correcto
            // esta es solo para descartar el boton de "limpiar filtros" en listado de productos
            let $submitInput = $submitInputs.filter(function() {
                return $(this).attr('data-drupal-selector') !== "edit-reset";
            });

            if ($submitInput.length > 0) {
                // Obtener texto input submit
                let submitTxt = $submitInput.val();
                let btnTemplate = `<button class="${btnClass} inputreplace" type="button">
                    <span class="button__txt">${submitTxt}</span>
                </button>`;
                // Ocultar input submit
                $submitInput.addClass('d-none');
                
                if( $formSelector.find('.form-actions .inputreplace').length <= 0 ){
                    // Insertar boton
                    $formSelector.find('.form-actions').append(btnTemplate);
    
                    // Agregar evento de clic al botón
                    $formSelector.find('.form-actions .inputreplace').on('click', function(){
                        // Disparar clic en el input submit original
                        $submitInput.trigger('click');
                    });
                }
            }
        
        }
    }

    function setLangValidationMessages(){
        // Añadimos Mensajes en español dependiendo el idioma
        if (getLanguage() == 'es') {
            jQuery('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.19.5/localization/messages_es.min.js" crossorigin="anonymous" referrerpolicy="no-referrer"></script>');
        }
    }

    function allFormFunctions(){
        // Set lang
        setLangValidationMessages();

        // Añadimos reglas de validación
        additionalValidationRules();
        // Formulario Contacto Home
        let $homeContactForm = $('.contact-home__form form');
        if($homeContactForm.length > 0){
            validateForm($homeContactForm);
            replaceInputWithBtn($homeContactForm);
        }
        // Formulario Newsletter
        let $newsletterForm = $('.newsletter__wrapper form');
        if($newsletterForm.length > 0){
            validateNewsletterForm($newsletterForm);
            replaceInputWithBtn($newsletterForm);
        }
        // Formulario Contacto
        let $contactForm = $('.contact-product__form form');
        if($contactForm.length > 0){
            validateForm($contactForm);
            replaceInputWithBtn($contactForm);
        }
        // Formulario Filtros Listado Productos
        let $formProductList = $('.filterbar__form form');
        if($formProductList.length > 0){
            replaceInputWithBtn($formProductList);
        }
        // Formulario Productos Home
        let $formProductsHome = $('.products-home form');
        if($formProductsHome.length){
            replaceInputWithBtn($formProductsHome, 'button--secondary');
            // mover boton "ver todos" dentro de actions en el form
            $formProductsHome.find('.form-actions').append( $('.products-home').find('.button--third') );
        }
        // Formulario Busqueda en Modal
        let $formSearchModal = $('.search-exposed-modal form');
        if($formSearchModal.length){
            replaceInputWithBtn($formSearchModal);
        }
    }

    allFormFunctions();

}

export default formFunctions;